import { QueryKey, UseQueryOptions, useQueryClient } from "react-query";
import { BILLING_ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";
import { useState } from "react";

type Response = {
  bucket: string;
  key: string;
  url: string;
};
type QueryError = {};

const useTransactionPDFQuery = (
  options?: UseQueryOptions<Response, QueryError, Response, QueryKey>
) => {
  const { fetchWithAuth } = useFetchWithAuth();
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);

  const getTransactionPDF = async (transactionId: number) => {
    const url = `${BILLING_ENDPOINT}/transactions/${transactionId}/pdf`;
    const cacheKey = [url];

    return queryClient.fetchQuery<Response, QueryError, Response, QueryKey>(
      cacheKey,
      async () => {
        setIsLoading(true);
        const result = await fetchWithAuth<Response>(url);
        setIsLoading(false);
        return result;
      },
      {
        ...options,
      }
    );
  };

  return { isLoading, getTransactionPDF };
};
export default useTransactionPDFQuery;
